import React from "react";
import {
  useHistory,
} from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core";
import { KButton } from "@kyburz/kdesign-system";
import { useDispatch } from "react-redux";

import useSetState from "../../../hooks/useTypedSetState";
import {setAlert} from "../../../redux/actions/actions";

import BaseLayout from "../../../components/layouts/BaseLayout";
import ValuesMappingEditor from "../components/valuesMappingEditor/ValuesMappingEditor";
import {useCreateMapping} from "../requests/valueMappings";

const useStyles = makeStyles(({ palette }: Theme) => ({
  layout: {
    height: "calc(100vh - 72px)",
    boxSizing: "border-box",
  },
  main: {
    height: "calc(100vh - 72px - 72px - 24px)",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  buttons: {
    width: "100%",
    height: 72,
    display: "flex",
    justifyContent: "flex-end",
    position: "fixed",
    padding: "16px 48px 0 0",
    bottom: 0,
    right: 0,
    borderTop: `1px solid ${palette.grey[300]}`,
    background: "white",
    gap: 16,
  },
}));

const VehicleMappingCreate: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { loading: saveLoading, request: createMapping } = useCreateMapping();

  const [mapping, setMapping] = useSetState({
    name: "",
    values: [{
      value: 0,
      label: {
        en: "",
        de: "",
        fr: "",
        it: "",
      }
    }]
  });

  const onCancel = () => history.push("/config/vehicle/templates/value_mappings");

  const onSave = () => {
    createMapping(mapping)
    .then(() => {
        dispatch(setAlert(`Mapping '${mapping.name}' has been saved`, "success"));
        onCancel();
      })
      .catch((err) => {
        dispatch(setAlert(err.message || "An error occurred", "error"));
        console.error(err);
      });
  };

  return (
    <BaseLayout
      title="Create New Values Mapping"
      handleArrowClick={() => history.push("/config/vehicle/templates/value_mappings/")}
      mainClassname={classes.layout}
    >
      <ValuesMappingEditor
        mapping={mapping}
        onMappingChanged={setMapping}
      />
      <footer className={classes.buttons}>
        <KButton children="Cancel" theme="secondary" onClick={onCancel} />
        <KButton
          children="Save and close"
          onClick={onSave}
          loading={saveLoading}
        />
      </footer>
    </BaseLayout>
  );
};

export default VehicleMappingCreate;
